import script from "./select-plan.vue?vue&type=script&setup=true&lang=js"
export * from "./select-plan.vue?vue&type=script&setup=true&lang=js"

import "./select-plan.vue?vue&type=style&index=0&id=687908a8&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-687908a8"]])

export default __exports__